import React from 'react'

const BigSentIcon = (props) => {
    return (
        <img src={props.selected ? "/assets/icons/big-sent.svg" : "/assets/icons/big-sent.svg"}
             alt="Sent"
             style={props.style}
        />
    )
}

export default BigSentIcon